import React, { useState } from 'react';
import { Button, Col, Row, Collapse } from "react-bootstrap-v5"
import { MInput } from "../../../components/MInput/MInput"
import { Filtro } from "../Partial/Filtro";

function FiltroDashBoard({ handleDownloadFiltro, filtros, handleLimparFiltro, GetDash }) {
    const [mostrarFiltros, setMostrarFiltros] = useState(false);

    const limparFiltro = () => {
        const inputs = filtros.filter(x => x.type === 'selectSearchNoFech');

        inputs.forEach(input => {
            const element = document.getElementById(input.campo);
            if (element) {
                element.value = "";
            }
        });

        handleLimparFiltro();
        GetDash(null, true);
    }

    return (
        <>
            {/* handleDownloadFiltro={handleDownloadFiltro} buttonHandleDownload handleFilter={GetDash} buttonHandleFilter ocultarNovo={true} chamada="filtrar_dashboard" */}
            <div style={{ display: 'flex', justifyContent: "start", alignItems: 'center', gap: '6px' }}>
                <Button className="mt-5 btn-sm btn-secondary" onClick={() => setMostrarFiltros(!mostrarFiltros)}>
                    <i className="fa fa-filter"></i>
                    {mostrarFiltros ? "Ocultar " : "Mostrar "} Filtros
                </Button>
                {mostrarFiltros && <Button className="mt-5 btn-sm btn-warning" alt="Limpar filtros" onClick={limparFiltro} >
                    <i class="fa fa-eraser" aria-hidden="true"></i>
                    Limpar filtro
                </Button>}
            </div>
            <Collapse in={mostrarFiltros}>
                <div>
                    <Row>
                        {filtros.map((filtro, i) => {
                            if (filtro.type == 'hidden') {
                                return (
                                    <MInput
                                        style={{ display: 'none' }}
                                        id={filtro.campo}
                                        type={filtro.type}
                                        title={filtro.titulo}
                                        data={filtro.data}
                                        value={filtro.selecionado}
                                        onChange={e => filtro.setSelecionado(e.target.value)}
                                    />
                                )
                            }
                            else if (filtro.type === "selectSearchNoFech") {
                                return (
                                    <Col key={`filtro_dash_${i}`} className="col-6 col-md-3">
                                        <MInput
                                            required={filtro.required}
                                            id={filtro.campo}
                                            type={filtro.type}
                                            title={filtro.titulo}
                                            default={filtro.campo == 'Data' ? 'Selecione' : "Todos"}
                                            data={filtro.data}
                                            value={filtro.selecionado}
                                            onSelect={e => filtro.setSelecionado(e)}
                                            onResult={res => res.map(z => ({ value: z.id, text: z.nome }))}
                                        />
                                    </Col>
                                )
                            }
                            else if (filtro.type !== "select") {
                                return (
                                    <Col key={`filtro_dash_${i}`} className="col-6 col-md-3">
                                        <MInput
                                            required={filtro.required}
                                            id={filtro.campo}
                                            type={filtro.type}
                                            title={filtro.titulo}
                                            data={filtro.data}
                                            value={filtro.selecionado}
                                            onChange={e => filtro.setSelecionado(e.target.value)}
                                        />
                                    </Col>
                                )
                            }
                            else {
                                return (
                                    <Col key={`filtro_dash_${i}`} className="col-6 col-md-3">
                                        <MInput
                                            required={filtro.required}
                                            id={filtro.campo}
                                            type={filtro.type}
                                            title={filtro.titulo}
                                            default={filtro.campo == 'Data' ? 'Selecione' : "Todos"}
                                            data={filtro.data}
                                            value={filtro.selecionado}
                                            onSelect={e => filtro.setSelecionado(e)}
                                            onResult={res => res.map(z => ({ value: z.id, text: z.nome }))}
                                        />
                                    </Col>
                                )
                            }
                        })}
                    </Row>
                    <div style={{ display: 'flex', justifyContent: "end", alignItems: 'center', gap: '5px' }}>
                        <Button className="mt-5 btn-sm" type="button" alt="Buscar" onClick={GetDash}>
                            <i class="fa fa-search" aria-hidden="true"></i>
                            Pesquisar
                        </Button>
                        <Button style={{ marginLeft: "10px" }} type="button" className="mt-5 btn-sm btn-secondary" alt="Buscar" onClick={handleDownloadFiltro}>
                            <i class="fa fa-download" aria-hidden="true"></i>
                            Download Resultado
                        </Button>
                    </div>
                </div>
            </Collapse>
        </>
    );
}

export default FiltroDashBoard;